import $auth from "@/assets/js/auth.js";
import $api from "@/assets/js/api.js";
import $router from "@/router";
import $errors from "@/assets/js/errors.js";
import { EventBus } from "@/assets/js/event-bus.js";
import $config from "@/app.config.js";
import pusher from "@/assets/js/pusher.js";

function initialState() {
  return {
    teams: {
      default: initialTeamState(),
    },
  };
}

function initialTeamState() {
  return {
    authenticated: false,
    token: "",
    team: null,
    account: null,
    accountCustomFields: null,
    cognito: {
      region: "",
      pool_id: "",
      client_id: "",
      username: "",
    },
    apiConfig: {
      invokeUrl: $config.api.invokeUrl,
      accessKey: "",
      secretKey: "",
      sessionToken: "",
      region: "",
      apiKey: "undefined",
      defaultContentType: "application/json",
      defaultAcceptType: "application/json",
    },
  };
}

const state = initialState;

const getters = {
  auth_get_teams: (state) => {
    return state.teams;
  },
};

const mutations = {
  AUTH_SET_TEAM(state, team) {
    state.teams[team.uid] = initialTeamState();
    state.teams[team.uid].team = team;
  },
  AUTH_SET_COGNITO(state, data) {
    state.teams[data.uid].cognito = data.cognito;
  },
  AUTH_SET_API(state, data) {
    state.teams[data.uid].apiConfig.invokeUrl = data.api;
  },
  AUTH_SET_AUTHENTICATED(state, data) {
    state.teams[data.uid].cognito.username = data.username;
    state.teams[data.uid].token = data.token;
    state.teams[data.uid].account && state.teams[data.uid].token !== ""
      ? (state.teams[data.uid].authenticated = true)
      : (state.teams[data.uid].authenticated = false);
  },
  AUTH_SET_ACCOUNT(state, data) {
    state.teams[data.uid].account = data.account;
    state.teams[data.uid].authenticated = state.teams[data.uid].token !== "" || !state.teams[data.uid].account;
  },
  AUTH_RESET_AUTH(state) {
    const s = initialState();
    Object.keys(s).forEach((key) => {
      state[key] = s[key];
    });
  },
  AUTH_LOGOUT_TEAM(state, team) {
    if (state.teams[team]) {
      const s = initialTeamState();
      Object.keys(s).forEach((key) => {
        if (key !== "team") {
          state.teams[team][key] = s[key];
        }
      });
    }
  },
  AUTH_SET_CURRENT_ACCOUNT_CUSTOM_FIELDS(state, data) {
    state.teams[data.team].accountCustomFields = data.customFields;
  },
};

const actions = {
  prepareRequest({ commit, state, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      const teamKey = payload && payload.team ? payload.team : $router.currentRoute.params.team;
      if (state.teams[teamKey]) {
        const data = {
          // UserPoolId: process.env.APP.cognito.UserPoolId,
          // ClientId: process.env.APP.cognito.ClientId
          UserPoolId: state.teams[teamKey].cognito.pool_id,
          ClientId: state.teams[teamKey].cognito.client_id,
        };
        // set cognito LastAuthUser in localstorage
        const key = "CognitoIdentityServiceProvider." + data.ClientId + ".LastAuthUser";
        localStorage.setItem(key, state.teams[teamKey].cognito.username);
        $auth
          .checkSession(data)
          .then((session) => {
            commit("AUTH_SET_AUTHENTICATED", {
              uid: teamKey,
              token: session.accessToken.jwtToken,
              username: session.accessToken.payload.username,
            });
            const auth = {
              team: state.teams[teamKey].team && state.teams[teamKey].team.uid ? state.teams[teamKey].team.uid : "",
              Authorization: state.teams[teamKey].token !== "" ? "Bearer " + state.teams[teamKey].token : "",
            };
            const res = Object.assign(auth, payload);
            resolve(res);
          })
          .catch((err) => {
            console.log(">>>>>>>>>>>>>>> check session logout", err);
            $errors.handle(err.response);
            commit("GLOBAL_LOADING_ENDED");
            commit("GLOBAL_DEFAULT_LOADING_ENDED");
            commit("GLOBAL_CUSTOM_LOADING_ENDED");
            dispatch("removeCognitoSession", teamKey);
            if (state.teams[teamKey].account) {
              dispatch("logout", {
                redirect: state.teams[teamKey].team.slug,
                logoutThisTeam: teamKey,
              });
            } else {
              $router.push("/login");
            }
            reject(err);
          });
      } else {
        console.log(">>>>> ROUTE PARAM NOT ACCESSIBLE");
      }
    });
  },
  getTeamBySlug({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_DEFAULT_LOADING_STARTED");
      $api(state.teams.default.apiConfig)
        .pTeamSlugGet(payload)
        .then((res) => {
          console.log("pTeamSlugGet", res);
          commit("AUTH_SET_TEAM", {
            uid: res.data.data.uid,
            slug: res.data.data.slug,
            name: res.data.data.name,
            passwordPolicy: res.data.data.auth.password_policy,
          });
          commit("AUTH_SET_COGNITO", {
            uid: res.data.data.uid,
            cognito: res.data.data.auth.cognito,
          });
          commit("AUTH_SET_API", {
            uid: res.data.data.uid,
            api: res.data.data.api,
          });
          commit("GLOBAL_DEFAULT_LOADING_ENDED");
          resolve(res);
        })
        .catch((err) => {
          console.log("err", err);
          $errors.handle(err.response, { custom: true });
          commit("GLOBAL_DEFAULT_LOADING_ENDED");
          reject(err);
        });
    });
  },
  loginAndGetAuthAccount({ commit, dispatch }, payload) {
    return new Promise((resolve, reject) => {
      // commit("GLOBAL_DEFAULT_LOADING_STARTED");
      $auth
        .login(payload.data)
        .then((res) => {
          console.log("login", payload, res);
          commit("AUTH_SET_AUTHENTICATED", {
            uid: payload.auth.team,
            token: res.accessToken,
            username: res.cognitoUser.username,
          });
          dispatch("getAuthAccount", payload.auth)
            .then((res) => {
              // commit('GLOBAL_DEFAULT_LOADING_ENDED')
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              // commit("GLOBAL_DEFAULT_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          $errors.handle(err.response ? err.response : err);
          // commit("GLOBAL_DEFAULT_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getAuthAccount({ commit, dispatch, state }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload)
        .then((res) => {
          $api(state.teams[payload.team].apiConfig)
            .teamAccountGet(res)
            .then((res) => {
              console.log("teamAccountGet", res);
              commit("AUTH_SET_ACCOUNT", {
                uid: payload.team,
                account: res.data.data,
              });
              commit("AUTH_SET_CURRENT_ACCOUNT_CUSTOM_FIELDS", {
                customFields: res.data.meta.custom,
                team: payload.team,
              });
              // commit('GLOBAL_DEFAULT_LOADING_ENDED')
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response, { team: payload.team });
              commit("GLOBAL_DEFAULT_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          console.log("err", err);
          $errors.handle(err.response, { team: payload.team });
          commit("GLOBAL_DEFAULT_LOADING_ENDED");
          reject(err);
        });
    });
  },
  editAuthAccount({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_LOADING_STARTED");
      dispatch("prepareRequest")
        .then((params) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamAccountPut(params, payload)
            .then((res) => {
              console.log("teamAccountPut", res.data.data);
              commit("GLOBAL_LOADING_ENDED");
              resolve(res);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response);
              commit("GLOBAL_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          console.log("err", err);
          $errors.handle(err.response);
          commit("GLOBAL_LOADING_ENDED");
          reject(err);
        });
    });
  },
  getTeamSubscription({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload)
        .then((res) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamBillingSubscriptionGet(res)
            .then((res) => {
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response, { team: payload.team });
              commit("GLOBAL_DEFAULT_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          console.log("err", err);
          $errors.handle(err.response, { team: payload.team });
          commit("GLOBAL_DEFAULT_LOADING_ENDED");
          reject(err);
        });
    });
  },
  postTeamSubscription({ commit, dispatch, rootState }, payload) {
    return new Promise((resolve, reject) => {
      dispatch("prepareRequest", payload)
        .then((res) => {
          $api(rootState.auth.teams[$router.currentRoute.params.team].apiConfig)
            .teamBillingSubscriptionPortalPost(res)
            .then((res) => {
              resolve(res.data.data);
            })
            .catch((err) => {
              console.log("err", err);
              $errors.handle(err.response, { team: payload.team });
              commit("GLOBAL_DEFAULT_LOADING_ENDED");
              reject(err);
            });
        })
        .catch((err) => {
          console.log("err", err);
          $errors.handle(err.response, { team: payload.team });
          commit("GLOBAL_DEFAULT_LOADING_ENDED");
          reject(err);
        });
    });
  },
  pinRequest({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_DEFAULT_LOADING_STARTED");
      $api(state.teams.default.apiConfig)
        .pPasswordTeamUserRequestPost(payload.team, payload.body)
        .then((res) => {
          console.log("pPasswordTeamUserRequestPost", res);
          commit("GLOBAL_DEFAULT_LOADING_ENDED");
          resolve();
        })
        .catch((err) => {
          console.log("err", err);
          $errors.handle(err.response);
          commit("GLOBAL_DEFAULT_LOADING_ENDED");
          reject(err);
        });
    });
  },
  pwReset({ commit, state }, payload) {
    return new Promise((resolve, reject) => {
      commit("GLOBAL_DEFAULT_LOADING_STARTED");
      $api(state.teams.default.apiConfig)
        .pPasswordTeamUserResetPost(payload.team, payload.body)
        .then((res) => {
          console.log("pPasswordTeamUserResetPost", res);
          commit("GLOBAL_DEFAULT_LOADING_ENDED");
          resolve();
        })
        .catch((err) => {
          console.log("err", err);
          $errors.handle(err.response);
          commit("GLOBAL_DEFAULT_LOADING_ENDED");
          reject(err);
        });
    });
  },
  removeCognitoSession({ state }, team) {
    console.log("=========>>>>>>>>>> REMOVE COGNITO SESSION", team);
    const localSession = JSON.parse(localStorage.getItem("localStorageEnvivo"));
    if (localSession) {
      delete localSession[team];
    }
    localStorage.setItem("localStorageEnvivo", JSON.stringify(localSession));
    localStorage.setItem("rememberMeEnvivo", JSON.stringify(localSession));
    sessionStorage.setItem("sessionStorageEnvivo", JSON.stringify(localSession));
    const data = {
      UserPoolId: state.teams[team].cognito.pool_id,
      ClientId: state.teams[team].cognito.client_id,
    };
    $auth.logout(data);
  },
  logout({ commit, state, dispatch }, payload) {
    let doNotRedirect = false;
    console.log(">>>>>>>>>>>>>>> LOGOUT", payload, state.teams, $router.currentRoute.params.team);
    let username, data;

    if (!$router.currentRoute.params.team && payload && payload.team) {
      username = state.teams[payload.team].cognito.username;
      data = {
        UserPoolId: state.teams[payload.team].cognito.pool_id,
        ClientId: state.teams[payload.team].cognito.client_id,
      };
    } else if ($router.currentRoute.params.team) {
      username = state.teams[$router.currentRoute.params.team].cognito.username;
      data = {
        UserPoolId: state.teams[$router.currentRoute.params.team].cognito.pool_id,
        ClientId: state.teams[$router.currentRoute.params.team].cognito.client_id,
      };
    }
    if (payload && payload.logoutAllTeams) {
      Object.keys(state.teams).forEach((key) => {
        if (key !== "default" && state.teams[key].authenticated && state.teams[key].cognito.username === username) {
          console.log("logout", key);
          pusher.unsubscribe(key, state.teams[key].account.uid);
          const localSession = JSON.parse(localStorage.getItem("localStorageEnvivo"));
          delete localSession[key];
          localStorage.setItem("localStorageEnvivo", JSON.stringify(localSession));
          localStorage.setItem("rememberMeEnvivo", JSON.stringify(localSession));
          sessionStorage.removeItem("sessionStorageEnvivo");
          commit("AUTH_LOGOUT_TEAM", key);
          commit("GLOBAL_RESET_GLOBAL_TEAM_SETTINGS", key);
        }
      });
    } else if (payload && payload.logoutThisTeam) {
      console.log("logout this team", payload.logoutThisTeam);
      pusher.unsubscribe(payload.logoutThisTeam);
      const localSession = JSON.parse(localStorage.getItem("localStorageEnvivo"));
      if (localSession) {
        delete localSession[payload.logoutThisTeam];
      }
      localStorage.setItem("localStorageEnvivo", JSON.stringify(localSession));
      localStorage.setItem("rememberMeEnvivo", JSON.stringify(localSession));
      sessionStorage.setItem("sessionStorageEnvivo", JSON.stringify(localSession));
      commit("AUTH_LOGOUT_TEAM", payload.logoutThisTeam);
      commit("GLOBAL_RESET_GLOBAL_TEAM_SETTINGS", payload.logoutThisTeam);
      doNotRedirect = true;
    } else {
      console.log("logout current team", $router.currentRoute.params.team);
      const currentRoute = $router.currentRoute.params.team;
      doNotRedirect = true;
      dispatch("checkAuthenticatedOnOtherTeam", {
        currentRoute,
        username,
        cb: () => {
          dispatch("logout", { logoutThisTeam: currentRoute });
        },
      }).then((res) => {
        console.log("checkAuthenticatedOnOtherTeam resolved", res);
        if (!res) {
          pusher.unsubscribe(currentRoute);

          const localSession = JSON.parse(localStorage.getItem("localStorageEnvivo"));
          if (localSession) {
            delete localSession[currentRoute];
          }
          localStorage.setItem("localStorageEnvivo", JSON.stringify(localSession));
          localStorage.setItem("rememberMeEnvivo", JSON.stringify(localSession));
          sessionStorage.setItem("sessionStorageEnvivo", JSON.stringify(localSession));
          commit("AUTH_LOGOUT_TEAM", currentRoute);
          commit("GLOBAL_RESET_GLOBAL_TEAM_SETTINGS", currentRoute);
          if (!res) {
            if (payload && payload.redirect) {
              $auth.logout(data);
              $router.push({ path: "/" + payload.redirect });
            } else {
              $auth.logout(data);
              $router.push("/login");
            }
          }
        }
      });
    }
    console.log("doNotRedirect", doNotRedirect);
    if (!doNotRedirect) {
      if (payload && payload.redirect) {
        $auth.logout(data);
        $router.push({ path: "/" + payload.redirect });
      } else {
        $auth.logout(data);
        $router.push("/login");
      }
    }
  },
  checkAuthenticatedOnOtherTeam({ state }, payload) {
    return new Promise((resolve) => {
      if (Object.keys(state.teams).length > 1) {
        for (let i = 0; i < Object.keys(state.teams).length; i += 1) {
          if (
            Object.keys(state.teams)[i] !== payload.currentRoute &&
            Object.keys(state.teams)[i] !== "default" &&
            state.teams[Object.keys(state.teams)[i]].authenticated &&
            state.teams[Object.keys(state.teams)[i]].cognito.username === payload.username
          ) {
            console.log("payload.currentRoute", payload.currentRoute, state.teams[Object.keys(state.teams)[i]]);
            console.log("found another team, switch", Object.keys(state.teams)[i]);
            EventBus.$emit("changeTeam", {
              uid: Object.keys(state.teams)[i],
              cb: payload.cb,
            });
            resolve(true);
            break;
          }
        }
        resolve(false);
      } else {
        resolve(false);
      }
    });
  },
  sessionClosedLogout({ state, commit }) {
    const username = state.teams[$router.currentRoute.params.team].cognito.username;
    const localSession = JSON.parse(localStorage.getItem("localStorageEnvivo"));
    let teamSessionFound = false;
    Object.keys(state.teams).forEach((key) => {
      Object.keys(localSession).forEach((sessionKey) => {
        if (key === sessionKey) {
          teamSessionFound = true;
        }
      });
      if (!teamSessionFound && state.teams[key].authenticated && state.teams[key].cognito.username === username) {
        console.log("logout", key);
        pusher.unsubscribe(key, state.teams[key].token, state.teams[key].account);
        commit("AUTH_LOGOUT_TEAM", key);
        commit("GLOBAL_RESET_GLOBAL_TEAM_SETTINGS", key);
      }
      teamSessionFound = false;
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
